import { render } from "./EmailSettingsAccount.vue?vue&type=template&id=e66e607e"
import script from "./EmailSettingsAccount.vue?vue&type=script&lang=js"
export * from "./EmailSettingsAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__